import { z } from 'zod'

import {
  BrandedMap,
  CreateBrandedEnum,
  type ZodInfer,
} from '@mntn-dev/utility-types'

export const [
  ChargeMethods,
  ChargeMethodSchema,
  ChargeMethodEnum,
  unbrandChargeMethod,
] = CreateBrandedEnum(
  { brand: 'ChargeMethod' },
  'mntn_credits',
  'meta',
  'tiktok',
  'linkedin',
  'invoice',
  'stripe',
  'ams'
)

export type ChargeMethod = ZodInfer<typeof ChargeMethodSchema>

export const ChargeMethod = (input: string): NoneableChargeMethod => {
  const result = ChargeMethodSchema.safeParse(input)
  return result.success ? result.data : 'none'
}

export const NoneableChargeMethodSchema = z.union([
  ChargeMethodSchema,
  z.literal('none'),
])
export type NoneableChargeMethod = ZodInfer<typeof NoneableChargeMethodSchema>

export function isChargeMethod(value: unknown): value is ChargeMethod {
  return ChargeMethodSchema.safeParse(value).success
}

export function assertIsChargeMethod(
  value: unknown
): asserts value is ChargeMethod {
  if (!isChargeMethod(value)) {
    throw new Error(`Invalid charge method: ${value}`)
  }
}

export const ChargeMethodPriority = new BrandedMap<ChargeMethod, number>({
  mntn_credits: 0,
  meta: 1,
  tiktok: 2,
  linkedin: 3,
  ams: 4,
  stripe: 5,
  invoice: 6,
})

export const byChargeMethod = (a: ChargeMethod, b: ChargeMethod): number =>
  ChargeMethodPriority.get(a) - ChargeMethodPriority.get(b)
